import Api from '../../api'
import axios from '@/js/api'
import breadcrumb from './breadcrumb.js'
import router from '@/router'
import date from '@/js/date.js'
const state = {
	userParameter: {
	  Keyword: "",
	  ExpertFromType: 0,
	  ExpertMajor: 0,
	  SrcHospitalGuid: "",
	  ExpertLevelType: "",
	  StartDate: "",
	  EndDate: "",
	  ModalityTypes: "",
	  Bodyparts: "",
	  PageIndex: 0,
	  PageCount: 0,
	  Enable: -1
	},
	workingteamParameter: {
		status: -1,
		type: 0,
		startDate: '',
		endDate: '',

	},
	pages: {
		name: '',
		pageIndex: 1,
		pageCount: 10,
		startDate: date.startDate, //开始时间
		endDate: date.endDate, //结束时间
	},
	splitScreen: false,
	pickerDate: {
		date: []
	},
	//专家组管理
	getUserlist: [],
	total: 0,
	isscreen: {
		specialist: false,
		workingteam: false,
	},
	//工作组管理
	expertGroupList: [],
	detailsRulesParameter: {
		types: [{
			Text: '影像',
			Value: 1
		}, {
			Text: '报告',
			Value: 2
		}, {
			Text: '影像和报告',
			Value: 3
		}],
		userFromType: [{
			Text: '全部',
			Value: 0
		}, {
			Text: '专委会',
			Value: 1
		}, {
			Text: '集团外',
			Value: 2
		}, {
			Text: '集团内',
			Value: 3
		}],
		ExpertFromType: [{
			Text: '未知',
			Value: 0
		},{
			Text: '专委会',
			Value: 1
		}, {
			Text: '集团外',
			Value: 2
		}, {
			Text: '集团内',
			Value: 3
		}],
		ExpertMajor: [{
			Text: '未知',
			Value: 0
		}, {
			Text: '超声',
			Value: 1
		}, {
			Text: '放射',
			Value: 2
		}, {
			Text: '核医学',
			Value: 3
		}],
		ModalityType:breadcrumb.state.detailsRulesParameter.modalityType,
		BodyPart:breadcrumb.state.detailsRulesParameter.BodyPart,
	},
	//新建工作组
	newWorkTeamFrom: {
		ExpertGroupGuid: "",
		name: "",
		Experts: [],
		Enable: true,
		Creator: "",
		Mender: "",
		type: ''
	},
	NewWorkTeamFromExperts: {
		Experts: false
	},
	//编辑
	GetExpertGroups: {
		expertGroupGuid: ''
	},
	ExpertGroupGuids: {
		ExpertGroupGuid: ''
	},
	//删除专家
	ExpertInfoDeleteArr: {
		ExpertGuid: ''
	},
	expertInfoUpdateArr: {
		ExpertGuid: "",
		Name: "",
		ExpertFromType: 0,
		ExpertMajor:0,
		Enable: true,
		ModalityTypes:[],
		BodyParts:[],
		ImageUrl:'',
		MaxQCCount:0,
		UnitPrice:0,
		SrcHospitalGuid:'',
		ExpertLevelType:'',
		Description:'',
		HospitalGuids:'',
		RegionGuid:'',
		ResourceType:1
	},
	loading: false,
	expertJobCountList: {},
	expertJobCountArr: {
		startdt: date.getLastBeginMonth(3).startdt,
		enddt: date.getLastBeginMonth(3).enddt,
		dataArr: date.getLastBeginMonth(3).dataArr,
		name: '',
		exportExcel: false,
	},
	loginStatiscsParamters:{
		keyword:'',
		roleGuids:'',
		pageIndex:1,
		pageCount:10,
		startdt: date.getLastBeginMonth(3).startdt,
		enddt: date.getLastBeginMonth(3).enddt,
	},
	loginStatiscslist:{
		list:[],
		TotalCount:0
	},
};
const getters = {

};
const mutations = {
	setReportModality(state, res){
        state.detailsRulesParameter.modalityType = res.data.Data;
		state.detailsRulesParameter.modalityType.forEach(item=>{
			item.text = item.Name;
		})
	},
	setBodyParts (state, res) {
		// state.setBodyPartsList = res.data;
		state.detailsRulesParameter.BodyPart = res.data.Data;
		state.detailsRulesParameter.BodyPart.forEach(item=>{
			item.text = item.Name;
		})
	  },
	setLoading(state, arr) {
		state.loading = arr;
	},
	clearInit(state) {
		state.pages.name = '';
		state.pages.pageIndex = 1;
		state.pages.pageCount = 10;
		state.pickerDate.date = [];
		state.userParameter.ExpertFromType = 0;
		state.userParameter.ExpertMajor = 0;
		state.userParameter.SrcHospitalGuid = '';
		state.userParameter.ExpertLevelType = '';
		state.userParameter.ModalityTypes = '';
		state.userParameter.Bodyparts = '';
		state.userParameter.Enable = -1;
	},
	clearexpertJobCountArr(state) {
		state.expertJobCountArr.startdt = date.getLastBeginMonth(3).startdt;
		state.expertJobCountArr.enddt = date.getLastBeginMonth(3).enddt;
		state.expertJobCountArr.dataArr = date.getLastBeginMonth(3).dataArr;
	},
	clearUserParameter(state) {
		state.userParameter = {
			Keyword: "",
			ExpertFromType: 0,
			ExpertMajor: 0,
			SrcHospitalGuid: "",
			ExpertLevelType: "",
			StartDate: "",
			EndDate: "",
			ModalityTypes: "",
			Bodyparts: "",
			PageIndex: 0,
			PageCount: 0,
			Enable: -1
		}
		state.pages = {
			keyword:'',
			pageIndex: 1,
			pageCount: 10,
		}
	},
	//设置专家管理组类型
	setUserFromType(state, arr) {
		state.userParameter.ExpertFromType = arr;
	},
	//分页
	currentChanges(state, val) {
		state.pages.pageIndex = val;
	},
	//展开
	setSplitScreen(state, arr) {
		state.splitScreen = arr;
	},

	setDatePicker(state, val) {
		if(val) {
			state.pages.startDate = date.dataNumber(val[0]);
			state.pages.endDate = date.dataNumber(val[1]);
		} else {
			state.pages.startDate = '';
			state.pages.endDate = '';
		}

	},
	//清空专家详情
	clearexpertInfoUpdateArr(state) {
		state.expertInfoUpdateArr = {
			ExpertGuid: "",
			Name: "",
			ExpertFromType: 0,
			ExpertMajor:0,
			Enable: true,
			ModalityTypes:[],
			BodyParts:[],
			ImageUrl:'',
			MaxQCCount:0,
			UnitPrice:0,
			SrcHospitalGuid:'',
			ExpertLevelType:'',
			Description:'',
			Title:''
		}
	},
	//工作组管理
	clearNewWorkTeamFrom(state) {
		state.pages.name = '';
		state.pages.pageIndex = 1;
		state.pages.pageCount = 1000;
		state.newWorkTeamFrom.Enable = true;
		state.newWorkTeamFrom.Experts = [];
		state.newWorkTeamFrom.name = '';
		state.newWorkTeamFrom.type = ''
	},
	//导航显示内容
	setIsscreen(state, arr) {
		state.isscreen.specialist = false;
		state.isscreen.workingteam = false;

		if(arr == 'specialist') {
			state.isscreen.specialist = true;
		}
		if(arr == 'workingteam') {
			state.isscreen.workingteam = true;
		}
	},
	//专家管理组
	setUserlist(state, arr) {
		state.getUserlist = arr.data.Experts;
		state.total = arr.data.TotalCount;
	},
	//工作组管理
	SetExpertGroupList(state, arr) {
		state.expertGroupList = arr.data.ExpertGroupList;
		state.total = arr.data.TotalCount;
	},
	//工作组编辑
	SetExpertGroup(state, arr) {
		let Enable = arr.data.ExpertGroup.Enable = 1 ? true : false
		state.newWorkTeamFrom.ExpertGroupGuid = arr.data.ExpertGroup.ExpertGroup;
		state.newWorkTeamFrom.name = arr.data.ExpertGroup.Name;
		state.newWorkTeamFrom.Experts = arr.data.Experts;
		state.newWorkTeamFrom.type = arr.data.ExpertGroup.Type;
		state.newWorkTeamFrom.Enable = Enable;

	},
	distributionlist(state, arr) {
		state.NewWorkTeamFromExperts.Experts = true;
		if(JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'))) {
			state.newWorkTeamFrom.Experts = JSON.parse(localStorage.getItem('NewWorkTeamFromExpertsList'));
		}

	},
	//新建专家
	setexpertInfoUpdateArr(state, arr) {
		let Enable = arr.Enable == 1 ? true : false;
		state.expertInfoUpdateArr = arr;
		state.expertInfoUpdateArr.Enable = arr.Enable;
		if (arr.ModalityTypes == null||arr.ModalityTypes == '') {
			state.expertInfoUpdateArr.ModalityTypes = [];
		}else{
			if(arr.ModalityTypes.length>0){
				state.expertInfoUpdateArr.ModalityTypes = arr.ModalityTypes.split(',')
			}
		} 

		if (arr.BodyParts == null||arr.ModalityTypes == '') {
			state.expertInfoUpdateArr.BodyParts = [];
		}else{
			if (arr.BodyParts.length>0) {
				state.expertInfoUpdateArr.BodyParts = arr.BodyParts.split(',')
			}
		}

	},
	expertJobCountMu(state, arr) {
		state.expertJobCountList = arr.data;
		state.total = arr.data.ResultCount;
	},
	setUserLoginList(state, arr) {
		state.loginStatiscslist = arr.data;
		state.loginStatiscslist.TotalCount = arr.data.TotalCount;
	},
};
const actions = {
	//获取检查部位
	GetBodyParts({
		state,
		commit,
		dispatch
	},arr) {
		axios.ajaxGet('get', Api.api.manager.GetBodyParts).then(res => {
				commit('setBodyParts', res);
		})
	},
    //设备类型
    GetReportModality({
        state,
        commit,
        dispatch
    },arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportModality).then(res => {
            if(res.data.StatusCode){
                commit('setReportModality', res);
            }
        })
    },
	//登录统计
	GetUserLoginList({
		commit,
		state
	}, arr) {
		commit('setLoading',true)
		axios.ajaxGet('get', Api.api.manager.GetUserLoginList, state.loginStatiscsParamters).then(res => {
			commit('setUserLoginList', res)
			commit('setLoading',false)
		})
	},
	//质控管理员查看专家工作量
	GetExpertJobCount({
		commit,
		state
	}, arr) {
		state.expertJobCountArr.pageIndex = state.pages.pageIndex;
		state.expertJobCountArr.pageCount = state.pages.pageCount;
		axios.ajaxGet('get', Api.api.specialist.GetExpertJobCount, state.expertJobCountArr).then(res => {
			commit('expertJobCountMu', res)
			commit('setLoading',false)
		})
	},
	GetExpertGroupList({
		commit,
		state
	}) {
		state.workingteamParameter.pageIndex = state.pages.pageIndex;
		state.workingteamParameter.pageCount = state.pages.pageCount;
		state.workingteamParameter.name = state.pages.name;
		state.workingteamParameter.startDate = state.pages.startDate;
		state.workingteamParameter.endDate = state.pages.endDate;
		axios.ajaxGet('get', Api.api.specialist.GetExpertGroupList, state.workingteamParameter).then(res => {
			commit('SetExpertGroupList', res)
			commit('setLoading',false)
		})
	},
	//创建工作组
	expertsCreateorupdate({
		state,
		commit,
		dispatch
	}) {
		let Enable = state.newWorkTeamFrom.Enable ? 1 : 0
		state.newWorkTeamFrom.Enable = Enable;
		state.newWorkTeamFrom.expertGroupGuid = state.GetExpertGroups.expertGroupGuid;
		axios.ajaxPost('post', Api.api.specialist.expertsCreateorupdate, state.newWorkTeamFrom).then(res => {
			state.pages.name = '';
			dispatch('GetExpertGroupList');
			commit('setSplitScreen', false);
			ELEMENT.Message.success(res.data.Msg);
			router.go(-1);
		})
	},
	//工作组编辑
	GetExpertGroup({
		state,
		commit
	}) {
		axios.ajaxGet('get', Api.api.specialist.GetExpertGroup, state.GetExpertGroups).then(res => {
			commit('SetExpertGroup', res)
			commit('setLoading',false)
			state.NewWorkTeamFromExperts.Experts = true
		})
	},
	//工作组管理
	GetExpertGroupList({
		commit,
		state
	}) {
		state.workingteamParameter.pageIndex = state.pages.pageIndex;
		state.workingteamParameter.pageCount = state.pages.pageCount;
		state.workingteamParameter.name = state.pages.name;
		state.workingteamParameter.startDate = state.pages.startDate;
		state.workingteamParameter.endDate = state.pages.endDate;
		axios.ajaxGet('get', Api.api.specialist.GetExpertGroupList, state.workingteamParameter).then(res => {
			commit('SetExpertGroupList', res)
			commit('setLoading',false)
		})
	},
	//工作组编辑
	GetExpertGroup({
		state,
		commit
	}) {
		axios.ajaxGet('get', Api.api.specialist.GetExpertGroup, state.GetExpertGroups).then(res => {

			commit('SetExpertGroup', res)
			commit('setLoading',false)
			state.NewWorkTeamFromExperts.Experts = true

		})
	},
	//工作组删除
	DeleteExpertGroup({
		state,
		commit,
		dispatch
	}) {
		axios.ajaxPost('post', Api.api.specialist.DeleteExpertGroup, state.ExpertGroupGuids).then(res => {

			if(res.data.code = 200) {
				dispatch('GetExpertGroupList')
				commit('setLoading',false)
				ELEMENT.Message.success(res.data.Msg)
			}
		})
	},
	//专家组管理
	userlist({
		commit,
		state,
		dispatch
	}, arr) {
		state.userParameter.PageIndex = state.pages.pageIndex;
		state.userParameter.PageCount = state.pages.pageCount;
		state.userParameter.Keyword = state.pages.name;
		axios.ajaxPost('post', Api.api.specialist.userlist, state.userParameter).then(res => {
			commit('setUserlist', res)
			commit('setLoading',false)
			if(arr == 'GetExpertGroup') {
				dispatch('GetExpertGroup')
			}
			if(arr == 'distribution') {
				commit('distributionlist', res)
			}
		})
	},
	//专家删除
	ExpertInfoDelete({
		state,
		commit,
		dispatch
	}) {
		axios.ajaxPost('post', Api.api.specialist.ExpertInfoDelete, state.ExpertInfoDeleteArr).then(res => {
			if(res.data.code = 200) {
				dispatch('userlist')
				commit('setLoading',false)
				ELEMENT.Message.success(res.data.Msg)
			}
		})
	},
	//创建专家
	ExpertInfoUpdate({
		state,
		commit,
		dispatch
	}) {
		let Enable = state.expertInfoUpdateArr.Enable ? 1 : 0
		state.expertInfoUpdateArr.Enable = Enable;

		axios.ajaxPost('post', Api.api.specialist.ExpertInfoUpdate, state.expertInfoUpdateArr).then(res => {
			dispatch('userlist');
			commit('setSplitScreen', false);
			commit('setLoading',false)
			ELEMENT.Message.success(res.data.Msg);
			router.go(-1);
		})
	},

}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}